import { inject } from '@angular/core';
import { ApiServerService } from '../../core/api';
import {
  AuthRequest, AuthResponse, CheckoutRequest, CheckoutResponse,
  PreauthRequest, PreauthResponse, RedirectRequest, RedirectResponse
} from './payment-api.models';

const baseUrl = 'payments';

export const injectPaymentApi = () => {
  const service = inject(ApiServerService);
  return {
    /** Initialises a checkout transaction and returns the transaction data.
     * @param data Checkout request payload.
     * @returns Checkout response containing transaction details.
     */
    checkout: (data: CheckoutRequest): Promise<CheckoutResponse> => {
      return service.call<CheckoutResponse, CheckoutRequest>(`${baseUrl}/checkout`, data);
    },

    /** Requests a payment redirect (Redsys hosted-page flow).
     * @param data Redirect request payload.
     * @returns Redirect response containing the URL and parameters for the Redsys hosted page.
    */
    redirect: (data: RedirectRequest): Promise<RedirectResponse> => {
      return service.call<RedirectResponse, RedirectRequest>(`${baseUrl}/redirect`, data);
    },

    /** Performs the 3DS pre-authorisation step (step 1).
     * @param data Preauth request payload.
     * @returns Preauth response containing transaction details.
     */
    preAuth: (data: PreauthRequest): Promise<PreauthResponse> => {
      return service.call<PreauthResponse, PreauthRequest>(`${baseUrl}/preauth`, data);
    },

    /** Completes the 3DS authorisation step (step 2).
     * @param data Auth request payload.
     * @returns Auth response indicating whether a challenge is required or if the process is done.
    */
    auth: (data: AuthRequest): Promise<AuthResponse> => {
      return service.call<AuthResponse, AuthRequest>(`${baseUrl}/auth`, data);
    },
  };
};

